import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const politicsSlice = createSlice({
    name: 'politics',
    initialState: {
        items: [],
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStatePolitic: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: "",
            }
        },
        setPolitics: (state, action) => {
            return {
                items: action.payload,
                item: {},
                message: "",
                error: "",
            }
        },
        setPolitic: (state, action) => {
            return {
                items: [],
                item: action.payload,
                message: "",
                error: "",
            }
        },
        setPoliticMessages: (state, action) => {
            return {
                items: [],
                item: {},
                message: action.payload,
                error: "",
            }
        },
        setPoliticError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getPoliticsThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/politics`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setPolitics(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setPoliticError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getPoliticThunk = (policy_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/politics/${policy_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setPolitic(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setPoliticError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const createPoliticThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.post(`/politics/createPolitics`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setPoliticMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setPoliticError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const updatePoliticThunk = (policy_id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/politics/updatePolitics/${policy_id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setPoliticMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setPoliticError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const deletePoliticThunk = (policy_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/politics/${policy_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setPoliticMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setPoliticError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const { 
    initialStatePolitic,
    setPolitics,
    setPolitic,
    setPoliticMessages,
    setPoliticError
} = politicsSlice.actions;

export default politicsSlice.reducer;